module.exports = __webpack_public_path__ + "img/credit.6d16deed.png";